import { Link } from 'react-router-dom';
import { useInView } from '../../../hooks/useInView';

export default function MidPageCTA() {
  const { ref, inView } = useInView();

  return (
    <section className="relative overflow-hidden py-24">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/01303addcf40ab4f2f830252a89a378a.jpg"
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, #0c0c0c 0%, #111111 50%, #0c0c0c 100%)' }} />
      </div>

      {/* Horizontal accent lines */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/25 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/25 to-transparent" />

      {/* Gold glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[200px] rounded-full pointer-events-none"
        style={{ background: 'radial-gradient(ellipse, rgba(201,168,76,0.07) 0%, transparent 70%)' }}
      />

      <div
        ref={ref}
        className={`relative z-10 max-w-7xl mx-auto px-8 lg:px-20 flex flex-col lg:flex-row items-center justify-between gap-10 transition-all duration-800 ${
          inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <div>
          <div className="flex items-center gap-4 mb-4">
            <div className="w-8 h-px bg-gold/50" />
            <p className="font-sans text-[0.58rem] tracking-[0.4em] uppercase text-gold font-medium">Ready to Start?</p>
          </div>
          <h2 className="font-serif font-bold text-white leading-tight" style={{ fontSize: 'clamp(2rem, 4vw, 3.5rem)', letterSpacing: '-0.02em' }}>
            Your Brand Deserves<br />
            <em className="not-italic text-gold">Broadcast-Level Excellence</em>
          </h2>
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-4 flex-shrink-0">
          <Link
            to="/contact"
            className="whitespace-nowrap group font-sans text-[0.68rem] font-semibold tracking-[0.2em] uppercase px-10 py-4 bg-gold text-[#020202] hover:bg-white transition-all duration-300 cursor-pointer inline-flex items-center gap-3"
          >
            Request Consultation
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
          </Link>
          <Link
            to="/services"
            className="whitespace-nowrap font-sans text-[0.68rem] font-medium tracking-[0.2em] uppercase px-10 py-4 border border-white/20 text-white hover:border-gold hover:text-gold transition-all duration-300 cursor-pointer"
          >
            Explore Services
          </Link>
        </div>
      </div>
    </section>
  );
}
